import React from "react";
import { useSearchParams } from "react-router-dom";
import { CrudPage } from "@/components/CrudPage";
import { StatusBadge } from "@/components/StatusBadge";
import { ROOM_STATUS } from "@/lib/constants";

const STATUS_OPTS = Object.entries(ROOM_STATUS).map(([value, v]) => ({ value, label: v.label }));

const columns = [
  { key: "property_id", label: "物件", render: (r, h) => <span className="font-medium">{h.nameOf("properties", r.property_id)}</span> },
  { key: "room_number", label: "部屋番号", render: (r) => r.room_number },
  { key: "layout", label: "間取り" },
  { key: "area", label: "面積", render: (r, h) => h.area(r.area) },
  { key: "rent", label: "賃料", render: (r, h) => h.yen(r.rent) },
  { key: "tenant_id", label: "入居者", render: (r, h) => (r.tenant_id ? h.nameOf("tenants", r.tenant_id) : "-") },
  { key: "status", label: "入居状況", render: (r) => <StatusBadge value={r.status} map={ROOM_STATUS} /> },
];

const fields = [
  { name: "property_id", label: "物件", type: "select", lookup: "properties", required: true },
  { name: "room_number", label: "部屋番号", required: true },
  { name: "floor", label: "階", type: "number" },
  { name: "layout", label: "間取り" },
  { name: "area", label: "面積(㎡)", type: "number" },
  { name: "rent", label: "賃料", type: "currency" },
  { name: "common_fee", label: "共益費", type: "currency" },
  { name: "management_fee", label: "管理費", type: "currency" },
  { name: "parking_fee", label: "駐車場料金", type: "currency" },
  { name: "other_fee", label: "その他費用", type: "currency" },
  { name: "deposit", label: "敷金", type: "currency" },
  { name: "key_money", label: "礼金", type: "currency" },
  { name: "status", label: "入居状況", type: "select", options: STATUS_OPTS, default: "vacant" },
  { name: "tenant_id", label: "入居者", type: "select", lookup: "tenants" },
];

export default function Rooms() {
  const [params] = useSearchParams();
  const pid = params.get("property_id");
  const isNew = params.get("new") === "1";
  return (
    <CrudPage
      title="部屋・区画管理"
      subtitle="各物件の部屋・区画と入居状況"
      endpoint="/rooms"
      resource="rooms"
      columns={columns}
      fields={fields}
      testid="rooms"
      addLabel="部屋を登録"
      searchKeys={["room_number", "layout"]}
      autoOpenNew={isNew && !!pid}
      newInitial={pid ? { property_id: pid } : null}
    />
  );
}
